import type { ReactNode } from 'react';

/**
 * A short row of steps — "Link made → Sent → Opened → Answered → Used on the
 * page", "Added → Pointing here → Secure → Live" — with the latest one reached
 * highlighted and the ones before it done.
 *
 * Not the kit's `StageTrack`: that is the business's four-stage journey with a
 * caption and a hint on every step, and it would be twice the height of the
 * card it sat in. This is the mockup's `.steps`, for progress *inside* a card.
 *
 * `reached` is an index into `steps`; the caller derives it from real state and
 * this draws it. Everything before it reads as done, it is `aria-current`, and
 * everything after is plain.
 */
export function Steps({
  label,
  steps,
  reached,
}: {
  label: string;
  steps: readonly string[];
  reached: number;
}): ReactNode {
  return (
    <ol className="site-steps" aria-label={label}>
      {steps.map((step, i) => (
        <li
          key={step}
          className={i < reached ? 'is-done' : i === reached ? 'is-on' : undefined}
          aria-current={i === reached ? 'step' : undefined}
        >
          {step}
        </li>
      ))}
    </ol>
  );
}
